import * as S from './styles'

export const SimulationCardSkeleton = () => {
  return (
    <S.SkeletonCard>
      <S.SkeletonHeader>
        <S.SkeletonTitle>
          <S.SkeletonLine width="120px" height="14px" />
          <S.SkeletonLine width="180px" height="18px" />
        </S.SkeletonTitle>
        <S.SkeletonActions>
          <S.SkeletonLine width="32px" height="32px" />
          <S.SkeletonLine width="32px" height="32px" />
        </S.SkeletonActions>
      </S.SkeletonHeader>
      <S.SkeletonContent>
        <S.SkeletonField>
          <S.SkeletonLine width="80px" height="12px" />
          <S.SkeletonLine width="120px" height="16px" />
        </S.SkeletonField>
        <S.SkeletonField>
          <S.SkeletonLine width="140px" height="12px" />
          <S.SkeletonLine width="100px" height="16px" />
        </S.SkeletonField>
      </S.SkeletonContent>
    </S.SkeletonCard>
  )
}
